import type { Layout } from "../Device";

export function shouldShowComposerSendButton(layout: Layout) {
  return layout === "phone";
}

export function getComposerEnterAction(
  layout: Layout,
  modifiers: Readonly<{ shiftKey?: boolean; ctrlKey?: boolean }>,
) {
  if (layout === "phone") {
    return modifiers.ctrlKey && !modifiers.shiftKey ? "send" : "newline";
  }

  return modifiers.shiftKey ? "newline" : "send";
}

export function getComposerSubmitKeyBinding(layout: Layout) {
  return layout === "phone" ? "Ctrl-Enter" : "Enter";
}
